function saveCustomRoute() {
	return {
		type: 'SAVE_CUSTOM_ROUTE'
	}
}

export { saveCustomRoute };